import { Action } from "../actions/actions";
import { SkeletonActionTypes } from "../actions/actionTypes";
import { Route } from "../api/apiTypes";

export function initialized(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case SkeletonActionTypes.INITIALIZE:
            return false;
        case SkeletonActionTypes.INITIALIZE_SUCCESS:
            return true;
        default:
            return state;
    }
}
